export default {
	INICIO: 'Inicio',
	COMUM: {
		PAGINA_NAO_AUTORIZADO: 'PaginaNaoAutorizado',
		PAGINA_NAO_ENCONTRADA: 'PaginaNaoEncontrada',
		REDIRECIONAR_EDITAR_USUARIO: 'RedirecionarEditarUsuario',
	},
	ADESAO: {
		ANUENCIA: 'AnuenciaFornecedorRoute',
		ADESAO_PUBLICA_VIEW: 'AdesaoPublicaView',
	},
	ATA: {
		ATA_VIEW: 'AtaView',
		ATA_ACESSAR_VIEW: 'AcessarAtaView',
	},
	DOCUMENTO: {
		BAIXAR: {
			ATA: 'BaixarDocumentoAta',
			PEDIDO: 'BaixarDocumentoPedido',
		},
	},
	RELATORIOS: {
		BAIXAR: {
			CONTROLE_SALDOS: 'BaixarRelatorioControleSaldos',
			CONTROLE_ADESOES: 'BaixarRelatorioControleAdesoes',
		},
	},
}
